import { route } from "../shim/jsbridge";
import * as notifications from "../notifications/notifications";
import storage from "./storage";
import api from "../services/api";

const bulkDownloadStorageKey = "bulkDownloadId";

const bulkDownload = {
  _notificationID: null,
  onload() {
    const { id: downloadId } = this._getOngoingDownloadData();
    if (downloadId && !this._dlgEl) {
      this._showPreparingDlg();
      this.poll();
    }
  },
  _showPreparingDlg(unpacked) {
    const content = `
      Preparing download${
        unpacked
          ? ", selected samples without extracted files will be skipped"
          : ""
      }... 
      <a href="#" class="bulk-download__cancel" onclick="tcbase.bulkDownload.cancel(); event.preventDefault();">CANCEL</a>
    `;
    this._notificationID = notifications.show({
      level: "info",
      html: true,
      sticky: true,
      message: content
    });
  },
  _closeNotification(id) {
    const event = new CustomEvent(notifications.NotificationEvent.DELETE, {
      detail: {
        id
      }
    });
    document.dispatchEvent(event);
  },
  _closeDlg() {
    this._closeNotification(this._notificationID);
    this._notificationID = null;
  },
  _setDownloadData(id, unpacked) {
    return storage.set(bulkDownloadStorageKey, { id, unpacked }, true);
  },
  _resetDownloadData() {
    return storage.set(bulkDownloadStorageKey, {}, true);
  },
  _getOngoingDownloadData() {
    return storage.get(bulkDownloadStorageKey, true) || {};
  },
  cancel() {
    const { id: downloadId, unpacked } = this._getOngoingDownloadData();
    api
      .bulkDownloadCancel(downloadId, unpacked)
      .then(() => {
        console.log("Download canceled.");
      })
      .catch(() => {
        console.log("Error while canceling download!");
      });

    storage.set(bulkDownloadStorageKey, {}, true);
    this._closeDlg();
    notifications.show({
      level: "info",
      message: "Download canceled."
    });
  },
  initDownload(samples, zipPassword, unpacked) {
    let { id: downloadId } = this._getOngoingDownloadData();
    if (downloadId) {
      notifications.show({
        level: "info",
        html: true,
        message: `Cannot start new download while current in progress.
                  <a href='#' onclick='tcbase.bulkDownload.cancel(); event.preventDefault();'>Cancel</a> current download.`
      });
      return;
    }

    if (samples.length > 700) {
      notifications.show({
        level: "info",
        message: "Initializing download ..."
      });
    }
    api
      .bulkDownloadInit(samples, zipPassword, unpacked)
      .then(response => {
        downloadId = response.data.download_id;
        this._setDownloadData(downloadId, unpacked);
        this._showPreparingDlg(unpacked);
        this.poll();
      })
      .catch(error => {
        let errMsg = "Download failed. Please try again.";
        if (error.data && error.data.message) {
          errMsg = error.data.message;
        }
        notifications.show({
          level: "error",
          message: errMsg
        });
        console.log(error);
      });
  },
  poll(timeout = 3000) {
    const { id: downloadId, unpacked } = this._getOngoingDownloadData();
    if (!downloadId) {
      console.log("Polling stopped.");
      return null;
    }
    return api
      .bulkDownloadCheck(downloadId)
      .then(response => {
        if (response.status === 202) {
          setTimeout(
            this.poll.bind(this),
            timeout,
            timeout <= 15000 ? timeout + 1000 : timeout
          ); // increase timeout on each poll
        } else {
          window.open(
            route(
              `api-download-bulk${unpacked ? "-unpacked" : ""}`,
              {},
              { id: downloadId }
            ),
            "_blank"
          );
          this._resetDownloadData();
          this._closeDlg();
          notifications.show({
            level: "success",
            message: "Download ready."
          });
        }
      })
      .catch(e => {
        this._closeDlg();
        this._resetDownloadData();
        notifications.show({
          level: "error",
          message: (e.data && e.data.msg) || "Download failed!"
        });
      });
  }
};

export default bulkDownload;
